.tagColor {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
